import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { Deliverable } from './useGetDeliverablesQuery'

type UpdateDeliverablesVariables = {
    deliverablesMap: Record<string, Deliverable>
}

export const useUpdateDeliverablesMutation = () => {
    const { getTokenSilently } = useAuth0()

    const updateDeliverables = async ({ deliverablesMap }: UpdateDeliverablesVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const response = await callAPI(
            endpoints.updateDeliverablesList.url,
            endpoints.updateDeliverablesList.method,
            token,
            { deliverablesMap }
        )

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to update deliverables')
        }

        return response.data
    }

    return useMutation(updateDeliverables)
}
